import { Button } from "../../../components"
import { FileInputField } from "../../../components/FileInputField"
import { MESSAGES } from "../constants/messages"

export const CsvUploadSection = ({ onFileUpload, isProcessing, onDownloadTemplate }) => {
  return (
    <>
      {/* Instructions Section */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6">
        <h3 className="text-lg font-semibold text-blue-900 mb-3">
          📋 {MESSAGES.INSTRUCTIONS.title}
        </h3>
        <div className="text-blue-800 space-y-2">
          {MESSAGES.INSTRUCTIONS.rules.map((rule, index) => (
            <p className="mb-0" key={index}>• {rule}</p>
          ))}
        </div>
        <div className="mt-4">
          <Button 
            onClick={onDownloadTemplate}
            className="bg-blue-600 hover:bg-blue-700 text-white"
          >
            📥 {MESSAGES.BUTTONS.downloadTemplate}
          </Button>
        </div>
      </div>

      {/* File Upload Section */}
      <div className="bg-white border border-gray-200 rounded-lg p-6 mb-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Upload do Arquivo CSV
        </h3>
        
        <FileInputField
          label="Selecione o arquivo CSV"
          onChange={onFileUpload}
          accepts={["text/csv", ".csv"]}
          multiple={false}
          maxFiles={1}
          placeholder={
            isProcessing 
              ? MESSAGES.PLACEHOLDERS.processing 
              : MESSAGES.PLACEHOLDERS.dragAndDrop
          }
          help="Aceita apenas arquivos .csv"
          maxFileSize={10000000} // 10MB
        />
      </div>
    </>
  )
} 